// The account pages' paths and the rules for a new account. Kept apart from
// accountApi.js so they can be imported without the map's modules.

export const SIGNUP_PATH = '/signup';
export const CONFIRM_PATH = '/confirm';
export const FORGOT_PATH = '/forgot-password';
export const RESET_PATH = '/reset-password';
export const PROFILE_PATH = '/profile';
// Not /login: that is the LogIn servlet's path, and rewrite.config would swallow its POSTs
export const LOGIN_PATH = '/log-in';
export const CHANGE_PASSWORD_PATH = '/change-password';
// The old saved locations page, now redirected to My reports' Area tab (AppRoutes.js)
export const LOCATIONS_PATH = '/locations';

// The Forgot password page, with the email filled in
export const forgotLink = (email) => FORGOT_PATH+(email ? '?email='+encodeURIComponent(email) : '');

// The OAuth client id for Sign up with Google. The Google button is left off
// the page until it is set (in .env.local for npm start, .env.production for builds).
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// The same rules as java/src/net/propstats/util/AccountUtil.java
export const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const PASSWORD_RULES = [
    {key:'length', text:'At least 8 characters', test:(p) => p.length >= 8},
    {key:'number', text:'A number', test:(p) => /\d/.test(p)},
    {key:'special', text:'A special character, like ! or #', test:(p) => /[^A-Za-z0-9]/.test(p)},
];

// The Subscribe page (Subscribe.js); its servlet is /subscription
export const SUBSCRIBE_PATH = '/subscribe';
// The sample reports anyone can open, real reports with the home's numbers hidden
// (scripts/make_sample_reports.sh writes them to js/public/samples)
export const SAMPLE_REPORTS = {
    buy:(process.env.PUBLIC_URL || '') + '/samples/buyers-report.pdf',
    rent:(process.env.PUBLIC_URL || '') + '/samples/renters-report.pdf',
    area:(process.env.PUBLIC_URL || '') + '/samples/area-report.pdf',
};

// The plan, its end date and cancelling (YourSubscription.js), from the account menu
export const YOUR_SUBSCRIPTION_PATH = '/your-subscription';
// Where Stripe sends back a payment that left the site (account/PaymentDone.js)
export const PAYMENT_DONE_PATH = '/payment-done';

// What each AI run costs in credits (CreditData.COST_*): a link check of a home to buy or to
// rent, an offer guide, an area guide
export const CREDIT_COSTS = {listing:5, rentListing:3, offer:5, area:1};

// The monthly plans. id is the substype stored in tuser.subscription
// (SubscriptionData.Plan in the servlet); credits a month are CreditData.allowance's.
export const SUB_PLANS = [
    {id:'standard', name:'Standard', price:'£9.99', pence:999, per:'a month', credits:60,
        note:'60 credits a month'},
    {id:'plus', name:'Plus', price:'£14.99', pence:1499, per:'a month', credits:115,
        note:'115 credits a month'},
];
export const planOf = (id) => SUB_PLANS.find((p) => p.id === id) || SUB_PLANS[0];

// A single report on one home, unlocked for 60 days (SingleReportData)
export const REPORT_PRICES = {buy:'£4.99', rent:'£2.99'};
export const REPORT_UNLOCK_DAYS = 60;
// The page that buys one (BuyReport.js)
export const BUY_REPORT_PATH = '/buy-report';
export const buyReportLink = (params) => BUY_REPORT_PATH + (params ? '?' + new URLSearchParams(params) : '');
// The page choosing between a single report and the plans, then finding the home (BuyPropertyReport.js)
export const BUY_PROPERTY_REPORT_PATH = '/buy';

// A top-up pack, for a subscriber who has run out (SubscriptionData.addTopup)
export const TOPUP = {price:'£4.99', credits:30};

// "£4.99" from pence
export const fmtPence = (p) => '£' + (p / 100).toFixed(2);
